import { useMemo } from "react";
import { mapAnswersToJokerUsedIndices, getFinalScoreDistribution } from "../shared/model/GameStatsEvaluation";
import { VerticalDistributionComponent } from "../shared/components/VerticalDistributionComponent";

export function OnePercentStatsComponent({ data }) {
  const wonGames = useMemo(() => data.filter(x => x.stats.gameWon).length, [data])
  const wonGamesShare = useMemo(() => (wonGames / data.length).toPrecision(4) * 100, [data, wonGames])

  const leftOverJokers = useMemo(() => data.map(x => x.stats.leftOverJokers).reduce((a,b) => a+b, 0) ?? 0, [data])

  const flawlessGames = useMemo(() => data.filter(x => x.stats.gameWon && x.jokers === 2).length, [data])

  const jokerUsedDistribution = useMemo(() => {
    const jokersUsed = data?.filter(x => x.stats.gameWon).map(x => x.answers).map(mapAnswersToJokerUsedIndices);
    return getFinalScoreDistribution(jokersUsed.flat())
  }, [data]);

  return (
    <section className="vertical-container justify">
      <span className="small bottom-margin">Der <i>Gewinn</i> setzt sich zusammen aus <i>gewonnenen Spielen</i> und <i>übrigen Jokern</i>.</span>
      {/* <span className="small">Ein Spiel zählt als <i>gewonnen</i>, wenn die <i>1%-Frage erreicht und richtig beantwortet</i> wurde.</span>
      <span className="small bottom-margin">Joker sind als <i>übrig</i> definiert, wenn sie bis zur 1%-Frage <i>nicht eingesetzt</i> wurden.</span> */}

      <div className="vertical-container top-margin gap-1">     
        <span>
          Du hättest in
          <span className="glow primary horizontal-padding"> {wonGames} </span>
          {wonGames === 1 ? "Spiel" : "Spielen"} gewonnen. Das sind
          <span className="glow primary horizontal-padding"> {wonGamesShare}% </span>
          aller deiner Spiele.
        </span>

        <span>
          Du hast dabei
          <span className="glow primary horizontal-padding"> {flawlessGames} </span>
          {flawlessGames === 1 ? "perfektes Spiel" : "perfekte Spiele"} gespielt: Du hast alle Fragen richtig beantwortet, ohne einen einzigen Joker zu benutzen.
        </span>

        <span>
          Wärst du in der Sendung gewesen, hättest du insgesamt schon
          <span className="glow primary horizontal-padding"> {wonGames * 100000 + leftOverJokers * 500}&nbsp;€ </span>
          gewonnen!
        </span>

        <div>
          Verteilung der <span className="">Joker-Einsätze in gewonnenen Spielen</span>:
          <VerticalDistributionComponent values={jokerUsedDistribution} />
        </div>

      </div>
    </section>
  );
}
